import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_NOTIFYPAYMENT_FULFILLED = "FETCH_NOTIFYPAYMENT_FULFILLED";
export const FETCH_NOTIFYPAYMENT_REJECTED = "FETCH_NOTIFYPAYMENT_REJECTED";
export const FETCH_NOTIFYPAYMENT_PENDING = "FETCH_NOTIFYPAYMENT_PENDING";
export const RESET_NOTIFYPAYMENT = "RESET_NOTIFYPAYMENT"

export function notifyPayment(applicationId, paymentIdentifier) {
    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_NOTIFYPAYMENT",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/second-opinion/notify-payment`,
                data: { applicationId, paymentIdentifier },
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetNOTIFYPAYMENT() {
    return (dispatch) => {
        dispatch({
            type: "RESET_NOTIFYPAYMENT",
        });
    };
}




